import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-textInput-control-value-view, [app-textInput-control-value-view]',
  templateUrl: './textInput-control-value-view.component.html',
  styleUrls: ['./textInput-control-value-view.component.scss']
})
export class TextInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
